export default __webpack_public_path__ + "static/media/Wolf's Gloves of the Covert Trail.a97abac4.jpg";